import {Approver} from '@domain/shifthandover'
import {EquipmentIdType} from '@hconnect/common'
import {SxProps, Theme} from '@mui/material'

export const getFormPrimaryButtonSx: SxProps<Theme> = (theme) => ({boxShadow: theme.shadows[4]})

export const getEquipmentIdType = (featureFlagEnabled: boolean): EquipmentIdType | undefined => {
  return featureFlagEnabled ? 'sapNumber' : undefined
}

export const getParameterChangeStates = (
  isEditMode: boolean,
  needsApproval: boolean = false,
  createdById?: string,
  userId?: string,
  approvers?: Approver[],
  isWaitingForApproval: boolean = false
) => {
  const isOwner = createdById === userId
  const isApprover = !!approvers?.find(({user}) => user.id === userId)
  const disableField = isEditMode && needsApproval && !isOwner && !isApprover
  const disableApproversField =
    disableField || (needsApproval && !isWaitingForApproval) || (isEditMode ? !isOwner : false)
  const disableNeedsApproval =
    disableField || (isEditMode && needsApproval) || (!isOwner && isEditMode)

  return {disableField, disableNeedsApproval, disableApproversField}
}
